<template>
    <div>
        <div style="width: 100%;margin-bottom: 20px;">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>app升级包</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <!-- 搜索筛选 -->
        <el-card class="box-card" style="margin-bottom: 20px;">
            <el-form :inline="true" class="user-search" :model="formInline">
                <el-form-item label="应用名称：">
                    <el-input size="small" placeholder="请输入订单编号" v-model="formInline.appName" clearable></el-input>
                </el-form-item>
                
                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="danger" icon="el-icon-plus" @click="handleadd">新增</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;" >
            <el-table-column type="index" width="50" align="center"> </el-table-column>
            <el-table-column prop="appName" label="名称" align="center"> </el-table-column>
            <el-table-column prop="lastVersion" label="版本号" align="center"> </el-table-column>
            <el-table-column prop="updateTime" label="更新时间" align="center"> 
                <template slot-scope="scope">
                    <div>
                        {{web.formatTime(scope.row.updateTime,'Y-M-D h:m')}}
                    </div>
				</template>
            </el-table-column>
            <el-table-column prop="upgradeInfo" label="内容提示" align="center"> </el-table-column>
            <el-table-column prop="wgtUrl" label="更新包地址" align="center"> </el-table-column>
            <el-table-column prop="pkgUrl" label="app安装包" align="center">
               
            </el-table-column>

			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button  size="mini" @click="handleedit(scope.row)">
						编辑
					</el-button>
                    <el-button  size="mini" @click="handledelete(scope.row)">
						删除
					</el-button>
				</template>
			</el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 弹框 设代理和设置会员-->
        <el-dialog       :close-on-click-modal="false" title="设置" :visible.sync="dialogVisible" width="500px">
            <el-form label-width="120px">

                <el-form-item label="APP名称">
                    
                    <el-select v-model="editForm.appName" placeholder="请选择APP名称" style="width: 300px;" >
                        <el-option label="qrs_android" value="qrs_android" ></el-option>
                        <el-option label="py_android" value="py_android" ></el-option>
                    </el-select>
                    <!-- qrs_android -->
                </el-form-item>
                <el-form-item label="版本">
                    <el-input v-model="editForm.lastVersion" style="width: 300px;"></el-input>
                </el-form-item>
               
                <el-form-item label="更新信息">
                    <el-input v-model="editForm.upgradeInfo"  type="textarea"
                    :rows="2"  style="width: 300px;"></el-input>
                </el-form-item>
                <!-- <el-form-item label="是否更新">
                    <el-radio-group v-model="editForm.isupdate">
                        <el-radio label="yes">更新</el-radio>
                        <el-radio  label="no">不更新</el-radio>
                   
                      </el-radio-group>
                
                </el-form-item> -->
                <el-form-item label="上传更新包">
                    <uploadwgt :url="editForm.wgtUrl" :name="editForm.lastVersion" @click="handleUpload"  style="width: 300px;"></uploadwgt>
                </el-form-item>
                <el-form-item label="地址信息" v-if="editForm.wgtUrl">
                    <el-input :value="editForm.wgtUrl" disabled  type="textarea"
                    :rows="2"  style="width: 300px;"></el-input>
                </el-form-item>
                <el-form-item label="上传安装包">
                    <uploadwgt :url="editForm.pkgUrl" :name="editForm.lastVersion" @click="handleUpload1"  style="width: 300px;"></uploadwgt>
                </el-form-item>
                <el-form-item label="安装包" v-if="editForm.pkgUrl">
                    <el-input :value="editForm.pkgUrl" disabled  type="textarea"
                    :rows="2"  style="width: 300px;"></el-input>
                </el-form-item>
             
            </el-form>
            <span slot="footer" class="dialog-footer" style="display: flex;justify-content: center;">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitedit" >提交</el-button>

            </span>
        </el-dialog>


    </div>
</template>

<script>
    import {getUpgradeInfoList , deleteAppUpgrade , saveAppUpgrade} from '../../api/basisMG.js'

    import uploadwgt from '@/components/uploadwgt'
    // 导出模块
    export default {
        components: {
            uploadwgt
                
        },

        // 模块数据
        data() {
            //数据  
            return {

                loading: true,
                visible: false,
                listData: [],
                dialogVisible: false,
                formInline:{},
                editForm:{}
                // 分页参数
              
            }
        },


        watch: {},

        methods: {
            handleUpload(url){
                // this.editForm.wgtUrl = url
                this.$set( this.editForm,'wgtUrl',url)
                console.log( this.editForm.wgtUrl)
            },
            handleUpload1(url){
                this.$set( this.editForm,'pkgUrl',url)
                // this.editForm.pkgUrl = url
                console.log( this.editForm.wgtUrl1)
            },
            handleadd(){
                this.dialogVisible = true
                this.editForm = {}
                
            },
            handleedit(row){
                this.dialogVisible = true
                this.editForm = Object.assign({}, row)
                
            },
            handledelete(row){
                this.$confirm('确认删除吗', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteAppUpgrade({upgradeId:row.id}).then(res=>{
                        if (res.code == '200') {
                            this.$message({
                           message:'删除成功',
                           type:'success'
                       })
                        this.getdata()
                        }
                       
                    })
                })
               
            },
            submitedit(){
                let param = this.editForm
                param.upgradeId = this.editForm.id
                this.$confirm('确认提交吗', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    saveAppUpgrade(param).then(res=>{
                    console.log(res)
                    if (res.code == '200') {  
                        this.$message({
                           message:'提交成功',
                           type:'success'
                       })
                    this.dialogVisible = false
                    this.getdata()
                     }
                   
                    })
                 
                })
               
            },
			getdata(){
				getUpgradeInfoList(this.formInline).then(res=>{
                    this.saveParams(this.$route.path,this.formInline)
					if(res.code==200){
						this.listData = res.data.content
						this.loading = false
						this.pageparm.total = res.data.totalElements
					}
				})
			},
	
        },
        // 创建前状态(里面是操作)
        beforeCreate() { },
        // 创建完毕状态(里面是操作)
        created() {
            this.getParams(this.$route.path)
			this.getdata()
        },
        // 挂载前状态(里面是操作)
        beforeMount() { },
        // 挂载结束状态(里面是操作)
        mounted() { },
        // 更新前状态(里面是操作)
        beforeUpdate() { },
        // 更新完成状态(里面是操作)
        updated() { },
        // 销毁前状态(里面是操作)
        beforeDestroy() { },
        // 销毁完成状态(里面是操作)
        destroyed() { }
    };
</script>

<style scoped>
   
</style>